const state = {
  testimonial: [],
  testimonial_id: [],
};

export default state;
